import axios from "axios";

// The JWT now lives in an httpOnly cookie set by the backend (not localStorage),
// so JavaScript can't read or leak it. Sending credentials makes the browser
// attach that cookie to every backend request automatically. Registered once,
// at app startup (see src/index.js).
axios.defaults.withCredentials = true;

// On 401 the token is missing/expired. Clear any client-side session state and
// notify the app so the UI reflects logged-out. The httpOnly cookie itself is
// cleared by the backend logout endpoint / its own expiry. We intentionally do
// NOT force a redirect here to avoid interrupting flows unexpectedly.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token"); // legacy cleanup (token no longer stored)
      localStorage.removeItem("user");
      window.dispatchEvent(new Event("auth-change"));
    }
    return Promise.reject(error);
  }
);

export default axios;
